import { useCurrentStateAndParams } from "@uirouter/react";

import { useGetCompanyInfo } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetCompanyInfo";

export const useCompanyName = (): string => {
    const {
        params: { domain },
    } = useCurrentStateAndParams<{ domain: string }>();

    const { data: companyData } = useGetCompanyInfo(domain);

    return companyData?.companyName ?? "";
};
